import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MetaService } from '../../services/meta-service';

@Component({
  selector: 'app-bloom-settings',
  templateUrl: './bloom-settings.component.html',
  styleUrls: ['./bloom-settings.component.scss'],
  standalone: false
})
export class BloomSettingsComponent implements OnInit {

  bloomMap: any;
  menuDisplayType: string = 'toolbar'; // Default value
  isFloatingToolbar: boolean = false;

  constructor(
    @Inject(MAT_DIALOG_DATA)
    public dataInput: any,
    public metaService: MetaService,
    public dialog: MatDialogRef<BloomSettingsComponent>
  ) { }

  ngOnInit(): void {
    this.bloomMap = this.dataInput.bloomMap;
    
    // Initialize settings from bloomMeta if they exist
    if (this.bloomMap && this.bloomMap.settings) {
      if (this.bloomMap.settings.menu_display_type) {
        this.menuDisplayType = this.bloomMap.settings.menu_display_type;
      }
      if (this.bloomMap.settings.is_floating_toolbar !== undefined) {
        this.isFloatingToolbar = this.bloomMap.settings.is_floating_toolbar;
      }
    }
  }

  saveSettings(): void {
    // Create settings object if it doesn't exist
    if (!this.bloomMap.settings) {
      this.bloomMap.settings = {};
    }
    
    // Update settings
    this.bloomMap.settings.menu_display_type = this.menuDisplayType;
    this.bloomMap.settings.is_floating_toolbar = this.isFloatingToolbar;
    this.dialog.close(this.bloomMap);
    // Update bloom meta
    // this.metaService.updateBloom(this.bloomMap)
    //   .then(response => {
    //     console.log("Bloom settings updated successfully", response);
    //     this.dialog.close(this.bloomMap);
    //   })
    //   .catch(err => {
    //     console.error("Error updating bloom settings", err);

    //   });
  }

  cancel(): void {
    this.dialog.close(false);
  }
}